export const filterOption = (input: string, options?: { label?: unknown }): boolean => {
  const { label } = options ?? {};
  return (
    (typeof label === 'string' || typeof label === 'number') &&
    label.toString().toLocaleLowerCase().includes(input.toLocaleLowerCase())
  );
};
